import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { PKDFilledButton } from 'components/FilledButton';
import { isMobile } from 'utils/isMobile';

export const Grid = styled(Box)(({ theme }) => ({
  display                      : 'grid',
  maxWidth                     : '1136px',
  gridTemplateColumns          : 'repeat(3, 1fr)',
  overflowX                    : 'auto',
  margin                       : '30px auto 0 auto',
  [theme.breakpoints.up('sm')] : {
    gap : '60px',
  },
}));

export const GridItem = styled(Box)({
  display       : 'flex',
  flexDirection : 'column',
  maxWidth      : '100%',
  padding       : isMobile() ? '0 18px' : 0,
  gap           : '20px',
});

export const List = styled('ul')(({ theme }) => ({
  listStyle   : 'none',
  fontFamily  : 'Montserrat',
  paddingLeft : 0,
  marginTop   : 0,
  '& li'      : {
    display      : 'flex',
    alignItems   : 'flex-start',
    gap          : '10px',
    marginBottom : '15px',
    img          : {
      marginTop : '5px',
    },
  },
}));

export const ContinueBtn = styled(PKDFilledButton)(({ theme }) => ({
  display      : 'block',
  margin       : '0 auto',
  marginBottom : '55px',
  marginTop    : '20px',
  fontSize     : '1rem',
  lineHeight   : 'unset',
  padding      : '13px',
  fontFamily   : 'Montserrat',
  fontWeight   : '700',
}));
